module.exports = __webpack_public_path__ + "img/recommend.b8091f57.svg";